//* 图片资源
import tsinghuaLogo2 from "@/assets/images/common/tsinghua2-0c7be6f6-f52c-4ab6-a6fe-4059031f4379.webp";
import tsinghuaLogo from "@/assets/images/common/tsinghua-4d7602a4-afe3-4bdc-9ab8-e56b15ce3460.webp";
//* 组件属性
import type { ComponentProps } from "../index";
import { useLocaleRoute } from "./utils";

export const useComposable = (define: ComponentProps) => {
    //* 插件
    const i18n = useI18n();
    const route = useRoute();

    //* 静态变量
    const vars = {
        language: <{ key: "zh" | "en"; src: string; name: string }[]>[
            { key: "zh", src: "https://rdgta.cdn.cyagen.com/rddc/pictures/c114ddb1-7ae3-4abb-aa1f-58c1669718cc.webp", name: "中文" },
            { key: "en", src: "https://rdgta.cdn.cyagen.com/rddc/pictures/6d7de203-f452-42b7-8896-cb6943899dba.webp", name: "EN" },
        ],
    };

    //* 计算属性
    const computeds = {
        //* Logo
        logos: computed(() => {
            //* 数据初始化
            const result = { tsinghua: "", cyagen: "" };
            //* 根据不同主题切换Logo
            if (define.dark) {
                result.tsinghua = tsinghuaLogo2;
                result.cyagen = "https://web.cdn.cyagen.com/cyagen-en-v2/pictures/4f27b72055b3f0b56f30aa2d1998947d.webp";
            } else {
                result.tsinghua = tsinghuaLogo;
                result.cyagen = "https://web.cdn.cyagen.com/cyagen-en-v2/pictures/117a88fd49ac4880a203bf504dd52b1d.webp";
            }

            return result;
        }),

        //* 路由配置
        routes: computed(() => {
            return {
                zh: useLocaleRoute(route, "zh"),
                en: useLocaleRoute(route, "en"),
            };
        }),
        //* 语言
        language: computed(() => {
            return {
                curr: vars.language.find((lang) => lang.key == route.meta.routeLanguage), //* 当前语言
                options: vars.language.filter((lang) => lang.key != route.meta.routeLanguage), //* 非当前语言
            };
        }),
    };

    //* 函数
    const methods = {
        //* 跳转登录页面
        login: () => {
            window.open(
                `${useRuntimeConfig().public.SSO_APP_URL}?uid=${useRuntimeConfig().public.SSO_APP_UID}&lang=${i18n.locale.value}&redirect=${
                    location.href
                }`,
                "_self"
            );
        },
    };

    return { vars, computeds, methods };
};
